import {JsonProperty} from '@hyperloris/tyson';
import {Account} from './account';
import {DateTime} from 'luxon';
import {AccountDefinition} from '../customer/account-definition';
import {Clearing} from './clearing';
import {ClearingInfo} from "./clearing-info";

export class Trade {
  @JsonProperty()
  id: string = undefined;
  @JsonProperty()
  parentTradeId: string = undefined;
  @JsonProperty()
  contractCode: string = undefined;
  @JsonProperty()
  contractVersion: string = undefined;
  @JsonProperty()
  exchangeCode: string = undefined;
  @JsonProperty()
  side: Trade.Side = undefined;
  @JsonProperty()
  price: number = undefined;
  @JsonProperty()
  avgPrice: number = undefined;
  @JsonProperty()
  avgPriceResidual: number = 0;
  @JsonProperty()
  avgPriceResidualGroup: number = 0;
  @JsonProperty()
  avgPriceResidualAlloc: number = 0;
  @JsonProperty()
  overrideAvgPrice: number = 0;
  @JsonProperty()
  avgRndPrice: number = 0;
  @JsonProperty()
  avgPriceGroupId: string = undefined;
  @JsonProperty()
  avgPriceResidualCurrency: string = undefined;
  @JsonProperty()
  volume: number = undefined;
  @JsonProperty()
  unmatchedVolume: number = undefined;
  @JsonProperty()
  exchangeReference: string = undefined;
  @JsonProperty()
  displayReference: string = undefined;
  @JsonProperty()
  orderReference: string = undefined;
  @JsonProperty()
  customOrderReference: string = undefined;
  @JsonProperty()
  freeText1: string = undefined;
  @JsonProperty()
  freeText2: string = undefined;
  @JsonProperty()
  freeText3: string = undefined;
  @JsonProperty()
  freeText4: string = undefined;
  @JsonProperty()
  technicalFreeText1: string = undefined;
  @JsonProperty()
  technicalFreeText2: string = undefined;
  @JsonProperty()
  technicalFreeText3: string = undefined;
  @JsonProperty()
  technicalFreeText4: string = undefined;
  @JsonProperty()
  strategy: string = undefined;
  @JsonProperty()
  strategyMissing: string = undefined;
  @JsonProperty()
  account: Account | undefined;
  @JsonProperty()
  openClose: AccountDefinition.OpenClose = AccountDefinition.OpenClose.NO;
  @JsonProperty()
  state: Trade.TradeState = Trade.TradeState.READY;
  @JsonProperty()
  executionDate: Date = new Date();
  @JsonProperty()
  localExecutionTime: string = undefined;
  @JsonProperty()
  businessDate: Date = new Date();
  @JsonProperty()
  clearingDate: Date = new Date();
  @JsonProperty()
  maturity: string = undefined;
  @JsonProperty()
  callPut: Trade.CallPut = Trade.CallPut.NONE;
  @JsonProperty()
  strike: number = undefined;
  @JsonProperty()
  giveIn: boolean = undefined;
  @JsonProperty()
  giveInBroker: string = undefined;
  @JsonProperty()
  giveInMessage: string = undefined;
  @JsonProperty()
  giveInMessage2: string = undefined;
  @JsonProperty()
  giveInMessage3: string = undefined;
  @JsonProperty()
  giveInCommission: string = undefined;
  @JsonProperty()
  giveUp: boolean = undefined;
  @JsonProperty()
  giveUpBrokerCode: string = undefined;
  @JsonProperty()
  giveUpMessage: string = undefined;
  @JsonProperty()
  giveupMessage2: string = undefined;
  @JsonProperty()
  giveupMessage3: string = undefined;
  @JsonProperty()
  giveupAccountType: string = undefined;
  @JsonProperty()
  giveUpCommission: string = undefined;
  @JsonProperty()
  source: string = undefined;
  @JsonProperty()
  origineTrader: string = undefined;
  @JsonProperty()
  trader: string = undefined;
  @JsonProperty()
  operatorId: string = undefined;
  @JsonProperty()
  ownerCode: string = undefined;
  @JsonProperty()
  owner: string = undefined;
  @JsonProperty()
  type: string = undefined;
  @JsonProperty()
  clearingBroker: string = undefined;
  @JsonProperty()
  creationDate: DateTime = DateTime.now();
  @JsonProperty()
  modificationDate: DateTime = DateTime.now();
  @JsonProperty()
  counterPartyMember: string = undefined;
  @JsonProperty()
  counterPartyTrader: string = undefined;
  @JsonProperty()
  executingFirm: string = undefined;
  @JsonProperty()
  orderId: string = undefined;
  @JsonProperty()
  execId: string = undefined;
  @JsonProperty()
  finalPrice: boolean = true;
  @JsonProperty()
  deltas: string = undefined;
  @JsonProperty()
  alertText: string = undefined;
  @JsonProperty()
  audit1: string = undefined;
  @JsonProperty()
  audit2: string = undefined;
  @JsonProperty()
  audit3: string = undefined;
  @JsonProperty()
  audit4: string = undefined;
  @JsonProperty()
  audit5: string = undefined;
  @JsonProperty()
  tradingEnvironment: string = undefined;
  @JsonProperty()
  customFreeTextField1: string = undefined;
  @JsonProperty()
  customFreeTextField2: string = undefined;
  @JsonProperty()
  customFreeTextField3: string = undefined;
  @JsonProperty()
  customFreeTextField4: string = undefined;
  @JsonProperty()
  clearingHouse: string = undefined;
  @JsonProperty()
  giveupGroupId: string = undefined;
  @JsonProperty()
  initialAccountRef: string = undefined;
  @JsonProperty()
  initialAccountRef2: string = undefined;
  @JsonProperty()
  initialAccountRef3: string = undefined;
  @JsonProperty()
  initialAccountType: string = undefined;
  @JsonProperty()
  initialOpenClose: AccountDefinition.OpenClose = undefined;
  @JsonProperty()
  exchangeMatched: boolean = true;
  @JsonProperty()
  exchangeStrategy: string = undefined;
  @JsonProperty()
  contractUnit: string = undefined;
  @JsonProperty()
  agressorInd: Trade.AggressorInd = Trade.AggressorInd.N;
  @JsonProperty()
  reversalRequested: boolean = false;
  @JsonProperty()
  reversalRejected: boolean = false;
  @JsonProperty()
  obLegRank: number | undefined;
  @JsonProperty()
  complexStrategy: string | undefined;

  @JsonProperty()
  clearings: Clearing[];

  @JsonProperty()
  clearingInfo: ClearingInfo | undefined;

}

export module Trade {
  export enum Side {
    BUY = 'BUY',
    SELL = 'SELL'
  }

  export enum TradeState {
    READY = 'READY',
    PENDING_GIVEIN = 'PENDING_GIVEIN',
    PENDING_REJECTED = 'PENDING_REJECTED',
    PENDING_SPLIT = 'PENDING_SPLIT',
    EXCEED_ACCEPTANCE_LIMIT = 'EXCEED_ACCEPTANCE_LIMIT',
    DISABLED = 'DISABLED'
  }

  export enum CallPut {
    NONE = 'NONE',
    CALL = 'CALL',
    PUT = 'PUT'
  }

  export enum AggressorInd {
    Y = 'Y', N = 'N'
  }
}
